import React from "react";
import CtaButton from "./CtaButton"

const DigitalCopyResult = () => {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 items-center justify-center p-4 sm:p-8 font-sans">
      <div className="relative flex flex-col md:flex-row w-full max-w-4xl bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Decorative background for the curved edge */}
        <div className="absolute inset-y-0 right-1/2 w-8 bg-slate-50 z-0 hidden md:block"></div>

        {/* Left Section: Description */}
        <div className="relative z-10 p-8 sm:p-10 md:w-1/2 flex items-center bg-white rounded-l-2xl">
          <div className="text-slate-700 text-lg leading-relaxed">
            <p className="mb-4">
              On our platform, you can create and train any employee,{" "}
              <span className="font-semibold text-cyan-500">
                even up to creating your own digital copy.
              </span>
            </p>
            <p>It's simple and requires no special skills or training.</p>
          </div>
        </div>

        {/* Right Section: Result */}
        <div className="relative p-8 sm:p-10 md:w-1/2 bg-slate-800 text-white flex items-center rounded-r-2xl">
          {/* This is the div that creates the curved shape for md and above */}
          <div className="absolute inset-y-0 -left-4 w-8 bg-white rounded-l-full z-0 hidden md:block"></div>

          <div className="relative z-10">
            <h3 className="text-2xl font-bold mb-4">Result:</h3>
            <p className="text-lg leading-relaxed">
              a unique AI employee who replaces a human, handles inquiries
              faster and better, never gets sick, and won't quit unexpectedly.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-16">
        <CtaButton
          buttonText="TRY FOR FREE"
          subText="14-day free trial for every user"
        />
      </div>
    </div>
  );
};

export default DigitalCopyResult;
